export const NAV_COUNTS_REFRESH_EVENT = 'eptw:nav-counts-refresh'

export const requestNavCountsRefresh = () => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new CustomEvent(NAV_COUNTS_REFRESH_EVENT))
}
